import { z } from 'zod';
import { baseMessageSchema, createMessageId } from './_base';

export enum UserProfileMessageType {
  USER_PROFILE_UPDATED = 'USER_PROFILE_UPDATED',
}

const userProfileUpdatedPayloadSchema = z.object({
  authId: z.string(),
  pointsBalance: z.number(),
  totalPointsEarned: z.number(),
  rank: z.string(),
  legacyDays: z.number(),
  timezoneOffsetMinutes: z.number().nullable(),
  firstSeenAt: z.string().or(z.number()),
  lastSeenAt: z.string().or(z.number()),
  frozenAt: z.string().or(z.number()).nullable(),
  frozenReason: z.string().nullable(),
  createdAt: z.string().or(z.number()),
  updatedAt: z.string().or(z.number()),
});

const userProfileUpdatedSchema = baseMessageSchema
  .extend({
    type: z.literal(UserProfileMessageType.USER_PROFILE_UPDATED),
  })
  .merge(userProfileUpdatedPayloadSchema);

export const userProfileMessageSchema = z.discriminatedUnion('type', [
  userProfileUpdatedSchema,
]);

export type UserProfileUpdatedPayload = z.infer<typeof userProfileUpdatedPayloadSchema>;
export type UserProfileMessage = z.infer<typeof userProfileMessageSchema>;

type PayloadType<T extends UserProfileMessageType> = T extends UserProfileMessageType.USER_PROFILE_UPDATED
  ? UserProfileUpdatedPayload
  : never;

export function generateUserProfileMessage<T extends UserProfileMessageType>(
  type: T,
  payload: PayloadType<T>,
): UserProfileMessage {
  const base = {
    id: createMessageId(),
    timestamp: Date.now(),
    type,
  };

  return userProfileUpdatedSchema.parse({
    ...base,
    ...payload,
  });
}
